import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Etiquette from './components/Etiquette';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminSubmissions from './components/AdminSubmissions';

// Main website page
const HomePage = () => (
  <>
    <Header />
    <Hero />
    <About />
    <Etiquette />
    <Services />
    <Gallery />
    <Testimonials />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-[#0a0908] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
